<script setup lang="ts">
const { statistics } = useReviewStatistics();

const averageRating = computed(() => {
  return statistics?.value?.data?.averageRating?.toFixed(2) || '....';
});

</script>

<template>
  <div
    class="rating-widget"
    role="complementary"
    :aria-label="$t('header.ariaLabelRating')">
    <NuxtLink :aria-label="$t('headerLinks.ratingLinkLabel')" :to="$t('headerLinks.ratingLink')" class="hover:underline">
      <div class="rating-text leading-none block text-sm sm:text-base font-bold text-black">
        <span :aria-label="$t('header.ariaLabelRatingText')">{{averageRating}}/</span>
        <span class="text-gray-500 font-light">5.00</span>
      </div>
    </NuxtLink>
    <div
      class="rating-stars gap-x-0 sm:gap-x-[4px] mt-0 text-[13px] sm:text-base flex text-rating-yellow relative ml-1 sm:ml-0"
      aria-hidden="true">
      <template v-for="starIndex in 5" :key="starIndex">
        <div class="relative inline-block">
          <!-- Background star (always gray) -->
          <i class="icon-star-sharp inline-block w-full h-full text-gray-300"></i>
          <!-- Foreground star (filled portion) -->
          <div 
            class="absolute top-0 left-0 bottom-0 h-full overflow-hidden"
            :style="{
              width: averageRating ? `${Math.min(100, Math.max(0, ((parseFloat(averageRating) - (starIndex - 1)) * 100))) }%` : '0%'
            }">
            <i class="icon-star-sharp inline-block w-full h-full text-rating-yellow"></i>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>